import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { IconOtherSound } from '@doltech/icons/IconOtherSound';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useSimpleAudioPlayInBackgroundStore } from '../../../hooks/simple-audio-play-in-background.store';
import { Typography } from '../../DesignSystemV2/Typography';

const Main = styled.div`
  display: grid;
  gap: 16px;
  .header {
    cursor: pointer;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 32px;
    .header-info {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 4px;
    }
  }

  .img-card-vocab {
    width: 100%;
    height: auto;
    object-fit: contain;
    ${fromScreen(540)} {
      width: 312px;
      height: 238px;
    }
  }
`;

interface CardVocabNewsProps {
  word: string;
  meaning: string;
  image?: any;
}

export const CardVocabNews = observer((props: CardVocabNewsProps) => {
  const { word, meaning, image } = props;
  const audioStore = useSimpleAudioPlayInBackgroundStore();
  return (
    <Main className="card-vocab-news">
      <div
        aria-hidden
        onClick={() => {
          audioStore.playByText(word);
        }}
        className="header"
      >
        <div className="header-info">
          <Typography.Paragraph variant="semi-bold/24" color="black100">
            {word} <IconOtherSound lineHeight={0} />
          </Typography.Paragraph>
          <Typography.Paragraph variant="regular/20" color="black60">
            {meaning}
          </Typography.Paragraph>
        </div>
      </div>
      <div className="content">
        <img
          className="img-card-vocab"
          alt="card-vocab"
          src={image?.url || 'https://dummyimage.com/312x238.png'}
        />
      </div>
    </Main>
  );
});
